import { RevealOnView } from "@/components/Reveal";
import { AXIOM } from "@/constants/testIds";

const CHAPTERS = [
  {
    n: "01",
    title: "Mission",
    body: "Provide high-value, scientifically rigorous engineering solutions through integrated design, simulation, prototype development, manufacturing support and experimental validation.",
  },
  {
    n: "02",
    title: "Vision",
    body: "To become the world's most trusted engineering innovation partner - enabling breakthrough technologies through advanced simulation, design, prototyping, manufacturing and experimental validation.",
  },
  {
    n: "03",
    title: "Values",
    body: "Deep technical rigor. Bias for prototypes over slide decks. Ownership from first principles to final unit shipped. Curiosity in front of every difficult problem.",
  },
];

export default function Manifesto() {
  return (
    <section id="about" data-testid={AXIOM.manifesto} className="relative bg-bg py-24 md:py-32 border-t border-rule">
      <div className="max-w-[1200px] mx-auto px-6 md:px-12">
        <RevealOnView>
          <div className="eyebrow mb-4">Manifesto</div>
          <h2
            className="font-display text-ink max-w-[18ch]"
            style={{ fontSize: "clamp(30px, 4vw, 46px)", lineHeight: 1.05, letterSpacing: "-0.02em" }}
          >
            We take on the problems <span className="text-forge">others avoid.</span>
          </h2>
          <div className="rule mt-10" />
        </RevealOnView>

        <div className="mt-10 grid grid-cols-12 gap-y-10">
          {CHAPTERS.map((c, i) => (
            <RevealOnView key={c.n} delay={i * 0.06} className="col-span-12">
              <div className="grid grid-cols-12 gap-6 items-start py-8">
                <div className="col-span-12 md:col-span-2">
                  <div className="font-mono text-[11px] tracking-[0.14em] text-forge uppercase">Chapter {c.n}</div>
                  <div
                    className="font-display text-ink mt-2"
                    style={{ fontSize: "clamp(40px, 4vw, 56px)", lineHeight: 1, letterSpacing: "-0.02em" }}
                  >
                    {c.n}
                  </div>
                </div>
                <div className="col-span-12 md:col-span-3">
                  <div
                    className="font-display text-ink"
                    style={{ fontSize: "28px", lineHeight: 1.1, letterSpacing: "-0.02em" }}
                  >
                    {c.title}
                  </div>
                </div>
                <div className="col-span-12 md:col-span-7">
                  <p className="text-ink/80 max-w-[62ch]" style={{ fontSize: "17px", lineHeight: 1.55 }}>
                    {c.body}
                  </p>
                </div>
              </div>
              {i < CHAPTERS.length - 1 && <div className="rule" />}
            </RevealOnView>
          ))}
        </div>
      </div>
    </section>
  );
}
